module.exports = __webpack_public_path__ + "static/media/logo13.6840d727.png";